(function ($) {
	'use strict';

	$(document).ready(function () {

		$('body').on('added_to_cart', function () {
			$('.cart-widget-side').addClass('wd-opened');
			if ($('.cart-side-widget').hasClass('wd-opened')) {
				$('.woodmart-close-side').addClass('woodmart-close-side-opened');
			}
		});
	});
})(jQuery);